import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './index.scss';

function TextInput({
  name,
  id,
  placeholder,
  type,
  value,
  onChange,
  fieldError,
}) {
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    if (value?.length > 0) setFocus(true);
  }, [value]);
  return (
    <label
      htmlFor={id}
      className={`text-input position-relative w-100 h-72 py-24 cursor-pointer px-30 br18 f-v-center ${
        focus || value?.length > 0 ? 'focus' : ''
      } ${fieldError ? 'error' : ''}`}
    >
      <span className="placeholder bg-white position-absolute">
        {placeholder}
      </span>
      <input
        type={type}
        name={name}
        id={id}
        className="border-none outline-none bg-transparent w-100 text-darkBlue"
        value={value}
        onChange={onChange}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
      />
    </label>
  );
}

TextInput.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  fieldError: PropTypes.bool,
  onChange: PropTypes.func,
};

TextInput.defaultProps = {
  name: '',
  id: '',
  placeholder: '',
  type: 'text',
  value: '',
  fieldError: false,
  onChange: () => {},
};

export default TextInput;
